import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ProductsAndPagesTopicIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M9.129 3.309c.601 0 1.166.235 1.591.66l9.75 9.749c.424.424.658.989.658 1.591s-.234 1.167-.658 1.591l-6.128 6.129c-.422.422-.995.659-1.592.657-.597.002-1.17-.235-1.591-.658l-9.75-9.75c-.424-.421-.66-.995-.659-1.592V5.559C.751 4.317 1.758 3.31 3 3.309h6.129zm0 1.5H3c-.414 0-.75.336-.75.75v6.128c0 .201.078.389.219.531l9.75 9.75c.142.142.33.219.531.219s.389-.078.53-.219l6.129-6.129c.292-.293.292-.768 0-1.061l-9.75-9.749c-.14-.141-.331-.22-.53-.22zm2.25-4.5c.601 0 1.165.234 1.59.658L23.03 11.028c.142.141.22.33.22.53s-.078.389-.22.53c-.142.141-.33.221-.53.221-.199 0-.39-.079-.53-.22L11.909 2.028c-.141-.14-.331-.218-.53-.219H4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.879zM6.798 7.765c.32.323.415.806.24 1.225-.174.42-.584.693-1.038.694-.62 0-1.125-.505-1.125-1.125.002-.455.276-.864.697-1.038.42-.173.904-.077 1.226.244z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ProductsAndPagesTopicIcon = __decorateClass([
  customElement("elm-products-and-pages-topic-icon")
], ProductsAndPagesTopicIcon);
export { ProductsAndPagesTopicIcon };
